import { Navigate } from "react-router";
import { useSplitCostingClusteredReportEnabled } from "../hooks";
import {
  ResultScreen,
  SplitCostingImportComposer,
  UploadScreen,
  ValidateScreen,
} from "../screens";

export const SPLIT_COSTING_IMPORT_BASE_PATH =
  "/onboarding/split-costing-import";

export function SplitCostingUploadExperienceRoute() {
  const singlePageEnabled = useSplitCostingClusteredReportEnabled();
  return singlePageEnabled ? <SplitCostingImportComposer /> : <UploadScreen />;
}

export function SplitCostingValidateExperienceRoute() {
  const singlePageEnabled = useSplitCostingClusteredReportEnabled();
  return singlePageEnabled ? (
    <Navigate to={SPLIT_COSTING_IMPORT_BASE_PATH} replace />
  ) : (
    <ValidateScreen />
  );
}

export function SplitCostingResultExperienceRoute() {
  const singlePageEnabled = useSplitCostingClusteredReportEnabled();
  return singlePageEnabled ? (
    <Navigate to={SPLIT_COSTING_IMPORT_BASE_PATH} replace />
  ) : (
    <ResultScreen />
  );
}
